export default __webpack_public_path__ + "724749c391874ad66f37eb9a2aec9755.png";